import { render } from "./CustomMultiSelectHorseSex.vue?vue&type=template&id=f6673a7c"
import script from "./CustomMultiSelectHorseSex.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelectHorseSex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__